import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 223.7 203.9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 0h164.09l59.61 203.9H57.82L0 0z",
      style: {"fill":"#e2001a","fill-rule":"evenodd"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M60.41 66.46c25.7-5.61 40.75 6.26 46.3 22.54-28.73-26.5-68.26-.72-55.15 27.43 9.72-16.27 27.5-24.7 48.1-20.52-45.07 10.8-40.75 53.35-14.04 59.4-7.78-15.84-4.1-34.2 15.84-48.38-20.59 31.75 11.88 65.16 41.83 46.01-24.19-5.69-38.16-29.02-32.47-40.82 12.24 36.94 63.22 29.38 62.21-4.32-10.8 10.8-36.65 15.12-52.63 1.3 40.18 10.37 63.07-29.67 35.14-50.98-.07 20.52-12.31 38.38-31.54 39.89 34.56-21.96 14.62-62.78-16.85-57.38 14.54 11.3 19.58 36 11.3 48.67 1.15-36.65-41.11-53.06-58.03-22.82Z",
      style: {"fill-rule":"evenodd","fill":"#fff"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "A9-logo"}) } }